import BackgroundSection from "@/components/BackgroundSection/BackgroundSection";
import appRightImg from "@/images/BecomeAnAuthorImg-2.png";
import appRightImgTree from "@/images/appRightImgTree.png";
import appSvg1 from "@/images/appSvg1.png";
import appSvg2 from "@/images/appSvg2.png";
import dowloadAppBGPng from "@/images/dowloadAppBG.png";
import ButtonPrimary from "@/shared/Button/ButtonPrimary";
const SectionHero = () => {
  return (
    <div className="relative pb-0 pt-24 lg:py-32 xl:py-40 2xl:py-48">
      <BackgroundSection className="bg-neutral-100 bg-opacity-80 dark:bg-opacity-100 ">
        <img
          className="absolute inset-0 w-full h-full object-cover rounded-3xl object-right"
          src={dowloadAppBGPng}
          alt="dowloadAppPng"
        />

        <div className="hidden lg:block absolute right-0 bottom-0 max-w-xl xl:max-w-2xl rounded-3xl overflow-hidden">
          <img src={appRightImg} alt="" />
        </div>
        <div className="absolute right-0 top-0 max-w-2xl">
          <img src={appRightImgTree} alt="" />
        </div>
        <div className="absolute left-0 bottom-10 max-w-2xl">
          <img src={appSvg1} alt="" />
        </div>
      </BackgroundSection>

      <div className="relative inline-block ">
        <h2 className="text-5xl md:text-6xl xl:text-7xl font-bold text-neutral-800">
        Unleash the Power of Digital Signage for Your Business
        </h2>
        <span className="block mt-7 max-w-md text-neutral-6000">
        Revolutionize Your Advertising with Our Digital Signage Solutions. Effortless management, real-time analytics, and unparalleled support for your advertising needs.
        </span>
        <div className="flex space-x-3 mt-10 sm:mt-14">
          <ButtonPrimary>
            <a href={"https://screens.adboardbooking.com"} target="_blank" >
          Signup for a free trial
            </a>
          </ButtonPrimary>
          <ButtonPrimary>
            <a onClick={()=>document.querySelector('#packages')?.scrollIntoView({
              behavior: 'smooth'
            })}>
          Explore Packages
            </a>
          </ButtonPrimary>
        </div>

        <img
          className="hidden lg:block absolute lg:left-full lg:top-0 xl:top-1/2 z-10  lg:max-w-sm 2xl:max-w-none"
          src={appSvg2}
          alt=""
        />

        <div className="block lg:hidden mt-10 max-w-2xl rounded-3xl overflow-hidden">
          <img src={appRightImg} alt="" />
        </div>
      </div>
    </div>
  );
};

export default SectionHero;
